import React, { useEffect, useState } from "react";
import { Card, Spin } from "antd";
import { GetRetailerContract } from "../../API  Functions/ProfileFunctions";
import { useSelector } from "react-redux";
import LoadingSpinner from "../Loading";
import { t } from "i18next";

const RetailerCommision = () => {
  const [loading, setLoading] = useState(false);
  const [contractData, setContractData] = useState(null);
  const company_id = useSelector(
    (state) => state?.login?.user?.result?.company_id
  );

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      const data = await GetRetailerContract(company_id);
      setContractData(data?.response); // adjust according to API
      setLoading(false);
    };
    fetchData();
  }, [company_id]);

  return (
    <div className="flex justify-center">
      <div
        className=" ms-2 me-2 p-6 w-full max-w-6xl"
      // style={{ borderRadius: "16px", marginTop: 25 }}
      >
        {/* Header */}
        <div className="flex items-center mb-4">
          {/* <div className="w-7 h-7 flex items-center justify-center bg-[#E6EBFF] rounded-full"> */}
          {/* <span className="text-[#1E3ABA] font-bold">%</span> */}
          {/* </div> */}
          <h2 className="text-lg font-normal">{t("myGINNE Commission")}</h2>
        </div>

        {/* Loader */}
        {loading ? (
          <LoadingSpinner></LoadingSpinner>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 mt-8 gap-6">
            {/* Standard Commission */}
            <div>
              <p className="text-gray-500 font-medium mb-2">
                {t("Standard Commission")}
              </p>
              <Card className="text-center bg-gray-50 shadow-none border rounded-lg">
                <h1 className="text-3xl font-bold text-[#1E3ABA]">
                  {contractData?.commission_percentage ?? 0}%
                </h1>
                <p className="text-gray-400 text-sm mt-1">{t("Base Commission")}</p>
              </Card>
            </div>

            {/* Category-wise Commission */}
            {contractData?.commission_category?.length > 0 && (
              <div>
                <p className="text-gray-500 font-medium mb-2">
                  {t("Category-wise - Commission")}
                </p>
                <div className="space-y-3">
                  {contractData?.commission_category?.length > 0 ? (
                    contractData.commission_category.map((item, index) => (
                      <div
                        key={index}
                        className="flex justify-between items-center bg-gray-50 p-3 rounded-lg"
                      >
                        <span className="text-gray-600">{item.category}</span>
                        <span className="font-semibold text-[#1E3ABA]">
                          {item.commission}%
                        </span>
                      </div>
                    ))
                  ) : (
                    <p className="text-gray-400 text-sm">
                      {t("No category-wise commission found")}
                    </p>
                  )}
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default RetailerCommision;
